<template>
    <div class="logo" :class="{ active: logoActive }" @click="setLogoActive" @mouseenter="resetLogoActive" @mouseleave="resetLogoActive">
        <RouterLink to="/">
            Zyno<strong>{{ rootStore.rootAppName ?? 'Suite' }}</strong>
            <template v-if="rootStore.subAppName">&nbsp;{{ rootStore.subAppName }}</template>
        </RouterLink>
        <FLauncherPopover class="launcher-popover" />
    </div>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { ref } from 'vue';
import FLauncherPopover from './f-launcher-popover.vue';

const rootStore = useStore();

const logoActive = ref(false);
function setLogoActive() {
    logoActive.value = true;
}
function resetLogoActive() {
    logoActive.value = false;
}
</script>

<style scoped>
@reference '#tw.css';

.logo {
    @apply text-white;
}

.logo {
    > a {
        @apply text-2xl;
        font-weight: 200;
    }

    > a > strong {
        @apply text-2xl;
        font-weight: 500 !important;
    }

    .launcher-popover {
        @apply absolute hidden z-[100];
    }

    &:hover:not(.active) .launcher-popover {
        @apply block;
    }
}
</style>
